module.exports = "https://files.cnvos.si/static/images/varstvo-okolja.png?e8d5c3206f2db11466906d4ba6cf7635";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/varstvo-okolja.png
// module id = 126
// module chunks = 1 2